(($, Drupal) => {
  Drupal.behaviors.recipeVideo = {
    attach: function (context, settings) {
      
      const $video = $('.recipe__marquee-image video', context);
      if (!$video.length) {
        return;
      }

      const $marquee_button = $('#marquee-button', context);
      const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
      
      // If video is present, hide video controls, respect prefers-reduced-motion.
      $(once('marquee-video', $video)).each(function () { 
        $(this).removeAttr('controls');
        if (!mediaQuery || mediaQuery.matches) {
          $marquee_button.find('img.pause-video').css('display', 'none');
          $marquee_button.find('img.play-video').css('display', 'block');
          $video.get(0).pause();
        }
      });

      // On button click, toggle background video play/pause.
      $(once('marquee-button-click', $marquee_button)).click(function() {        
        if ($video[0]['paused']) {
          $marquee_button.find('img.pause-video').css('display', 'block');
          $marquee_button.find('img.play-video').css('display', 'none');
          $video.get(0).play();
        }
        else {
          $marquee_button.find('img.pause-video').css('display', 'none');
          $marquee_button.find('img.play-video').css('display', 'block');
          $video.get(0).pause();
        }
      });

    }
  }
})(jQuery, Drupal);
